/**
 * Enum Phương pháp tính giá
 * NVTUAN1 12.08.2022
 */
export default {
  //Bình quân cuối kỳ
  ClossingAverage: 0,
  //Bình quân tức thì
  ImmediateAverage: 1,
  //Đích danh
  RealName: 2,
  //Nhập trước xuất trước
  FirstInFirstOut: 3,
};
